import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1A1A2E", // Dark blue for primary elements like the header or main buttons
    },
    secondary: {
      main: "#0A74DA", // Light blue for secondary actions like links or secondary buttons
    },
    background: {
      default: "#F5F5F5", // Light gray background for the main app screen
      paper: "#FFFFFF", // White background for cards, modals, or paper elements
    },
    error: {
      main: "#C13584", // Dark pink for error or warning messages
    },
    warning: {
      main: "#D4AF37", // Gold for important highlights or action buttons
    },
  },
  typography: {
    fontFamily: "Arial, sans-serif",
    h1: {
      color: "#1A1A2E", // Dark blue for main headings
    },
    h2: {
      color: "#16213E", // Slightly darker blue for sub-headings
    },
    button: {
      textTransform: "none", // Prevent button text from being capitalized
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "#0D5C8C", // Darker blue for hover effect on primary buttons
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderWidth: "2px", // Default border thickness
            "& fieldset": {
              borderColor: " #e6e6e6", // Light gray border
              borderWidth: "2px",
            },
            "&:hover fieldset": {
              borderColor: "  #b0b0b0", // Darker gray on hover
            },
            "&.Mui-focused fieldset": {
              borderColor: " #D4AF37", // Gold border on focus
              borderWidth: "2.5px",
            },
          },
        },
      },
    },
  },
});

export default theme;
